import { render, staticRenderFns } from "./SelecaoItensPedidoListagem.vue?vue&type=template&id=20ab1fc2"
import script from "./SelecaoItensPedidoListagem.vue?vue&type=script&lang=js"
export * from "./SelecaoItensPedidoListagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports